<template>
  <div>
    <v-text-field
      placeholder="Votre réponse ..."
      multi-line
      v-model="answer"
    ></v-text-field>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "Verbatim",
    data: () => ({
      answer: ``,
    }),
    computed: {
      ...mapState([
        `currentQuestion`,
      ]),
    },
    methods: {
      clear () {
        this.answer = ``;
      },
    },
    watch: {
      answer (newAnswer) {
        this.$emit(`canValidate`, newAnswer.length > 0);
        this.$emit(`newAnswer`, newAnswer);
      },
    },
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// Verbatim.vue?1d7cbf69